import {useEffect, useState} from "react";
import {useAppDispatch} from "../../hooks";
import {setBackSchemaStateField} from "../../features/schemaManageSlice";
import {apiFetch} from "../util";
import {Exception} from "@zxing/library";

export default function useLoadManageSchema(projectName: string, backend: string, skip = false) {
    const [isStateLoaded, setIsStateLoaded] = useState<boolean>(false)

    const dispatch = useAppDispatch();

    useEffect(() => {
        if (skip) {
            setIsStateLoaded(true)
            return;
        }
        if (!projectName || !backend)
            return

        const loadSchema = async () => {
            const proj = await apiFetch(`${backend}/astra/getSchema.php?project=${projectName}&type=project`);
            if (proj.success) {
                dispatch(setBackSchemaStateField("proj", proj.body.data))
            } else throw new Exception("failed to fetch")

            const {success, body: {data}} = await apiFetch(`${backend}/astra/getSchema.php?project=${projectName}&type=allTables`);
            if (success) {
                const tables = Object.keys(data['rich']);
                dispatch(setBackSchemaStateField("tables", data['rich']))
                dispatch(setBackSchemaStateField("staticTables", data['static']))
                dispatch(setBackSchemaStateField("etherealTables", data['ethereal']))
                dispatch(setBackSchemaStateField("sqlSelectQueries", data['sqlSelect']))
                dispatch(setBackSchemaStateField("selectedTable", tables.length > 0 ? tables[0] : null))
            } else throw new Exception("failed to fetch")
        };
        loadSchema().then(_ => setIsStateLoaded(true)).catch();
    }, [projectName, dispatch, backend]);

    return isStateLoaded
}
